<form [formGroup]="form">
  <div class="card mb-3 bg-2">
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12 col-md-4">
          <lib-autocomplete #grupocarteiraAutocomplete [schema]="grupocarteiraSchema"></lib-autocomplete>
        </div>
      </div>
    </div>
    <div class="card-footer clearfix">
      <div class="d-flex flex-row justify-content-end">
        <div class="pr-3">
          <button
            mat-raised-button
            color="primary"
            [disabled]="form.invalid || (loading$ | async)" label="Pesquisar"
            type="submit"
            (click)="totalRegistros = 0; page$.next(1); pesquisar(this.form)"
            title="Pesquisar"
            aria-label="left">
            <loading-icon [btnLabel]="'Pesquisar'" [loading]="loading$ | async"></loading-icon>
          </button>
        </div>
        <button mat-raised-button
                [matMenuTriggerFor]="menuExportarRegra"
                [disabled]="(loadingExport$ | async) || !showExecutar">
          <loading-icon
            [btnLabel]="'Exportar'"
            [loading]="loadingExport$ | async"
          ></loading-icon>
          <span class="caret"></span>
        </button>
        <mat-menu #menuExportarRegra="matMenu">
          <button mat-menu-item (click)="exportarPdf()">
            <span>PDF</span>
          </button>
          <button mat-menu-item (click)="exportarXls()">
            <span>Excel</span>
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
</form>
<app-total-table (onChange)="onChangeTotalPagina($event)" [totalRegistros]="this.totalRegistros"></app-total-table>
<table
  class="table label-maps table-striped table-bordered table-hover table-responsive-sm table-responsive-md table-responsive-xl">
  <thead>
  <tr>
    <th>Nome</th>
    <th>Descrição</th>
    <th class="text-center">Ações</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let gc of gruposcarteiras">
    <td>{{ gc.nome }}</td>
    <td>{{ gc.descricao }}</td>
    <td class="pt-1 pb-1" style="width: 250px;">
      <div class="d-flex flex-row justify-content-center">
        <div class="pr-2">
          <button mat-icon-button type="button" (click)="openEditDialog(gc)" title="Editar">
            <i class="fas fa-edit" aria-hidden="true"></i>
          </button>
        </div>
        <div class="pr-2">
          <button mat-icon-button color="warn" type="button" (click)="openDeleteDialog(gc.id)" title="Excluir">
            <i class="fas fa-trash" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div class="d-flex justify-content-center mb-5">
  <maps-pagination [items]="paginationTotalPage" [pageNumber]="page$"
                   *ngIf="paginationTotalPage && paginationTotalPage > 0"
                   (pageSend)="receiverPage($event)"></maps-pagination>
</div>
